import { useState } from "react";
import { Button } from "@altimateai/lego";
import { EditIcon } from "@/assets/icons";
import { Tag } from "../types";
import TagFormDialog from "./TagFormDialog";

interface EditTagButtonProps {
  tag: Tag;
}

const EditTagButton = ({ tag }: EditTagButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <Button variant="ghost" size="icon" onClick={handleClick} title={`Edit ${tag.display_name}`}>
        <EditIcon className="h-4 w-4 al-text-brand" />
      </Button>
      {isDialogOpen && <TagFormDialog tag={tag} onClose={handleClose} />}
    </>
  );
};

export default EditTagButton;
